import React from 'react';
import {
    PanelHeader,
    Div,
    Spinner,
    SplitCol,
    SplitLayout,
    Button,
    Search, ButtonGroup, ModalPageHeader, PanelHeaderButton, ModalPage, ModalRoot
} from '@vkontakte/vkui';
import axios from "axios";

import {
    Icon24BrowserBack,
    Icon24Cancel,
    Icon24Info
} from "@vkontakte/icons";
import IncomingProducts from "./IncomingProducts";
import {AdaptivityContext, setQuizStep} from "../assets/constants";
import * as constants from "../assets/constants";
import IncomingDocsViewer from "./IncomingDocsViewer";
import IncomingStepHeader from "./StepHeader";


class IncomingStep1 extends React.Component {

    state = {
        mainSearch: '',
        items: [],
        cnt_products: 0,
        loading: true
    }

    constructor(props) {
        super(props);

    }

       getItems = () => {
        clearInterval(this.searchInterval);

        this.setState({loading: true})

        let body = new FormData()
        body.append('ids', JSON.stringify(this.props.ids))

        axios.post(this.props.base_url + '?app=incomings&act=getDocItems', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            this.setState({loading: false, items: response.data.items ?? []})


            this.setState({cnt_products: response.data.items ? response.data.items.length : 0})

        })

    }
    componentDidMount() {
        this.getItems()
    }

    onSearchChange = (e) => {
        this.setState({mainSearch: e.target.value})
    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '');


        return (
            <SplitLayout >
                <SplitCol>
                    <PanelHeader fixed={true}>
                        <Div>
                            Приемка. Шаг 1
                        </Div>
                    </PanelHeader>
                    <IncomingStepHeader currentDocs={this.props.currentDocs} onSearchChange={this.onSearchChange} step={1} />
                    <SplitLayout>
                        <SplitCol>
                            {this.state.loading ? <Spinner size="large"/> : ''}
                            <IncomingProducts hideInput
                                              readonly
                                              items={this.state.items}
                                              search={this.state.mainSearch}
                                              base_url={this.props.base_url}
                                              images_url={images_url}
                                              currentDocs={this.props.currentDocs}
                                              current_user={this.props.current_user}
                            />
                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout>
                        <SplitCol>
                            <Div className="action-board">
                                <ButtonGroup mode="horizontal" stretched style={{justifyContent: 'end'}}>

                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            style={{maxWidth: '50%'}}
                                            onClick={() => setQuizStep(2, 'Incoming')}>Далее</Button>
                                </ButtonGroup>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                </SplitCol>
            </SplitLayout>)
    }
}

export default IncomingStep1